<template>
  <div class="footer__wrapper">
    <div class="footer">
      <p class="footer__copyright">{{ general[0].copyright }}</p>
      <div class="social__wrapper">
        <!-- <a :href="'mailto:' + general[0].contact.email"><img class="social__icon" src="../assets/social/mail.svg" alt=""></a> -->
        <a :href="general[0].social.instagram" target="_blank"><img class="social__icon" src="../assets/social/instagram.svg" alt=""></a>
        <a :href="general[0].social.behance" target="_blank"><img class="social__icon" src="../assets/social/behance.svg" alt=""></a>
        <a :href="general[0].social.ello" target="_blank"><img class="social__icon" src="../assets/social/ello.svg" alt=""></a>
      </div>
      <div class="placeholder">

      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'foot',
  computed: {
    ...mapGetters([
      'general'
    ])
  }
}
</script>
<style lang="scss">
@import "../scss/vars";

.footer__wrapper {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0 25px;
  box-sizing: border-box;
}
.placeholder {
  display: none;
  width: 0;
}
.footer {
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  flex-flow: row;
  align-items: center;
  & p {
    margin: 0;
  }
  padding-bottom: 3rem;
}
.footer__copyright {
  text-align: right;
  color: $font-color__second;
  font-weight: bold;
}
.social__wrapper {
  width: 10rem;
  display: flex;
  flex-flow: row;
  justify-content: space-between;
}
.social__icon {
  height: 1.5rem;
}
@media screen and (min-width: $break-small) {

}
@media screen and (min-width: $break-large) {
  .placeholder {
    width: 10rem;
  }
}

</style>
